var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoiceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon invoice",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z",
    "data-name": "Rectangle 61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 4h-4V0zm-4 1h4v9.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-13A1.5 1.5 0 0 1 3.5 0H9v4a1 1 0 0 0 1 1zM4 2.75a.252.252 0 0 0 .25.25h2.5A.251.251 0 0 0 7 2.75v-.5A.251.251 0 0 0 6.75 2h-2.5a.252.252 0 0 0-.25.25zM4.25 5h2.5A.251.251 0 0 0 7 4.75v-.5A.251.251 0 0 0 6.75 4h-2.5a.251.251 0 0 0-.25.25v.5a.251.251 0 0 0 .25.25zm3.922 4.9-.2-.05c-.713-.219-.7-.347-.672-.459.043-.244.518-.3.946-.238A3.23 3.23 0 0 1 8.8 9.3a.626.626 0 0 0 .41-1.182 5.1 5.1 0 0 0-.58-.165V7.75a.625.625 0 0 0-1.25 0v.187a1.55 1.55 0 0 0-1.311 1.241c-.231 1.339 1.037 1.711 1.579 1.87l.182.053c.915.262.9.35.873.509-.043.244-.518.3-.947.238a4.385 4.385 0 0 1-.739-.22l-.14-.051a.626.626 0 0 0-.416 1.18l.133.047a6.514 6.514 0 0 0 .783.235v.211a.625.625 0 1 0 1.25 0v-.2a1.543 1.543 0 0 0 1.307-1.232c.232-1.349-1.065-1.718-1.762-1.918z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoice-icon.0e4d7d7ab52af25482e95da2b553e3d2.svg";
export { ForwardRef as ReactComponent };